import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

// Phase 2Z.n — Coverage Guard V1 hook. Fetches the existing
// /api/coverage-rules collection ONCE per surface mount + lets the
// caller refetch on demand (after the manager edits a rule in the
// drawer). Zero backend changes.
export function useCoverageGuard() {
  const [rules, setRules] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/coverage-rules?active_only=false");
      setRules(Array.isArray(data) ? data : []);
      setError(null);
    } catch (err) {
      // Graceful failure — Coverage Guard shows a grey shield rather
      // than blocking the page.
      setRules([]);
      setError(err?.response?.data?.detail || "Failed to load Coverage Guard rules");
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/coverage-rules?active_only=false");
        if (cancelled) return;
        setRules(Array.isArray(data) ? data : []);
        setError(null);
      } catch (err) {
        if (cancelled) return;
        setRules([]);
        setError(err?.response?.data?.detail || "Failed to load Coverage Guard rules");
      } finally {
        if (!cancelled) setLoaded(true);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return { rules, loaded, error, reload };
}
